var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdPlatformLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1519_27169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5032 1.20763C26.717 -0.402545 23.283 -0.402544 20.4968 1.20763L4.49677 10.4541C1.71398 12.0622 0 15.0324 0 18.2464V36.7542C0 39.9683 1.71399 42.9384 4.49678 44.5466L20.4968 53.793C23.283 55.4032 26.717 55.4032 29.5032 53.793L45.5032 44.5466C48.286 42.9384 50 39.9683 50 36.7542V18.2464C50 15.0324 48.286 12.0622 45.5032 10.4541L29.5032 1.20763ZM24.9994 39.1903C31.8354 36.9933 36.1237 26.9744 36.638 21.7785C34.5171 17.9129 28.6278 15.8088 24.9994 15.8088C21.371 15.8088 15.4818 17.9129 13.3609 21.7785C13.8752 26.9744 18.1635 36.9933 24.9994 39.1903Z",
    fill: "url(#paint0_linear_1519_27169)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1519_27169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.45312,
    y: -0.800781,
    width: 54.9414,
    height: 55.8185,
    fill: "url(#paint1_linear_1519_27169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.789 24.0569C44.6273 41.9271 31.0812 41.6748 24.9589 39.1708L14.2535 19.9056L6.15625 24.0569V44.0225L19.6475 54.833L57.8987 61.2206C58.0962 41.3868 56.9507 6.18674 50.789 24.0569Z",
    fill: "url(#paint2_linear_1519_27169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.635 21.7752C32.8178 4.42712 14.5436 4.04111 5.60291 5.8912C-3.02602 6.32951 -6.50379 19.0677 -7.16406 25.3821L-3.03739 48.4871L13.4245 49.7375C5.48084 37.4492 10.0552 25.7766 13.3651 21.7752L36.635 21.7752Z",
    fill: "url(#paint3_linear_1519_27169)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1519_27169",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 55.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7872F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1519_27169",
    x1: 33.4652,
    y1: 7.7983,
    x2: 25.5513,
    y2: 41.0544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054746,
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1519_27169",
    x1: 48.3206,
    y1: 37.4496,
    x2: 8.2296,
    y2: 34.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1519_27169",
    x1: 4.18411,
    y1: 27.2864,
    x2: 30.2628,
    y2: 14.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5109C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdPlatformLogo);
export default __webpack_public_path__ + "static/media/NfdPlatformLogo.e833d7cf270c70b5e9e3af438ac23b0e.svg";
export { ForwardRef as ReactComponent };